import { DisplayMode } from '@/types/display-mode';
import { SquareCheck, SquareM, SquareMinus, SquareX } from 'lucide-react';

import { useUser } from '../../hooks/use-user';
import { ActorRole } from '../../lib/graphql/generated/graphql';
import DisplayModeButtonDropdown from './displaymode-button-dropdown';
import DisplayModeButtonTabs from './displaymode-button-tabs';
import { ChooseIcon } from './status-label';

export type TabConfig = {
  mode: DisplayMode;
  dataUserGuide?: string;
  internalOnly?: boolean;
};

export const TAB_CONFIGS: TabConfig[] = [
  { mode: DisplayMode.SELECTED },
  { mode: DisplayMode.DESELECTED, dataUserGuide: 'Excluded from offer' },
  { mode: DisplayMode.ERROR, dataUserGuide: 'To complete' },
  { mode: DisplayMode.MODIFIED },
  { mode: DisplayMode.MODIFIED_BY_CHOOSE, internalOnly: true },
];

export function TabIcon({
  mode,
  role,
}: {
  mode: DisplayMode;
  role?: ActorRole;
}) {
  const icon = 'size-4 shrink-0';
  const RoleIcon = role === ActorRole.Brand ? ChooseIcon : SquareM;

  switch (mode) {
    case DisplayMode.SELECTED:
      return <SquareCheck className={`${icon}`} />;
    case DisplayMode.DESELECTED:
      return <SquareMinus className={`${icon}`} />;
    case DisplayMode.ERROR:
      return <SquareX className={`${icon} text-red-500`} />;
    case DisplayMode.MODIFIED:
      return <RoleIcon className={`${icon}`} />;
    case DisplayMode.MODIFIED_BY_CHOOSE:
      return <ChooseIcon className={`${icon}`} />;
  }
}

export const tabsDropdownLimit = 540;
function DisplayModeButtons() {
  const user = useUser();
  const tabs = TAB_CONFIGS.filter(
    (tab) => !tab.internalOnly || user?.isInternalUser
  );

  const hideDopdownClass =
    tabs.length > 4 ? '@tabs-choose:hidden' : '@tabs-brand:hidden';

  const showTabsClass =
    tabs.length > 4 ? '@tabs-choose:block' : '@tabs-brand:block';

  return (
    <div className="w-full @container">
      {/* lg+: tabs (lg shrunk icon tabs, xl icon tabs, 2xl text + tabs) */}
      <div className={`${showTabsClass} hidden`}>
        <DisplayModeButtonTabs tabs={tabs} />
      </div>
      {/* &lt; lg: dropdown */}
      <div className={`${hideDopdownClass} block`}>
        <DisplayModeButtonDropdown tabs={tabs} />
      </div>
    </div>
  );
}

export default DisplayModeButtons;
